// this file contains constants for the different page names associated with Reset Password wizard

export const ANSWER_SECURITY_QUESTIONS_PAGE = 'ANSWER_SECURITY_QUESTIONS_PAGE';
export const RESET_YOUR_PASSWORD_PAGE = 'RESET_YOUR_PASSWORD_PAGE';
export const RESET_PASSWORD_COMPLETE_PAGE = 'RESET_PASSWORD_COMPLETE_PAGE';
export const YOUR_ACCOUNT_IS_LOCKED_PAGE = 'YOUR_ACCOUNT_IS_LOCKED_PAGE';
